import React from 'react'

// CardCurrencyBrandLegend returns an unordered list of footnotes in HTML format.
// These footnotes should match up with footnotes declared by objects processed by the CodeCurrencyFormat or CurrenciesCell objects.
// If your content won't include one of these footnotes, comment out the line item.
// When your content includes a footnote that isn't defined, add a definition in the unordered list. Follow the same syntax as the other footnotes.
// CardCurrencyBrandLegend takes no input.
// The footnote character is returned in code format.
// Include a brief definition of the footnote. You can use HTML if needed.
// If you need a lot of detail for a footnotes, consider formatting the object in CardCurrencySpecialCurrencies and adding a .

const CardCurrencyBrandLegend = () => {
  return (
    <>
      <a id="link-footnote-legend" />
      <p>
        <ul>
          <li>
            <a id="link-footnote-0" />
            <strong>0</strong> indicates a 0-digit denomination currency. If you
            pass a decimal amount, an error occurs.
          </li>
          <li>
            <a id="link-footnote-2" />
            <strong>2</strong> indicates a 2-digit denomination currency that
            uses multiples of 0.20 in the decimal place. See{' '}
            <a href="#link-specialcurrencies">
              <strong>Special currencies</strong>
            </a>{' '}
            for more details.
          </li>
          <li>
            <a id="link-footnote-3" />
            <p>
              <strong>3</strong> indicates a 3-digit denomination currency. Pass
              a 0 in third decimal place, or only pass non-0 amounts up to the
              first 2 decimal places.
            </p>
            <p>
              If you pass an amount in the incorrect format, the amount will be
              rounded down to the second decimal place, and the third decimal
              place will be replaced with a 0 to allow the payment to go
              through. For example, passing KWD 101.123 will be rounded down to
              KWD 101.120.
            </p>
          </li>
        </ul>
      </p>
    </>
  )
}

export default CardCurrencyBrandLegend
